import type { SVGProps } from 'react';

export const Trash = (props: SVGProps<SVGSVGElement>) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
        <path d='M20 7h-4V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2H4v2h2v10a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9h2V7ZM10 5h4v2h-4V5Zm6 14H8V9h8v10Z' />
        <path d='M11 11H9v6h2v-6ZM14 11h-2v6h2v-6Z' />
    </svg>
);
